import axios from 'axios';
import _ from 'lodash';
import * as types from '../constants/ActionTypes';

function requestPopularQuestions() {
  return {
    type: types.REQUEST_POPULAR_LIST,
  };
}


function receivePopularQuestions(response, experience) {
  const articles = _.get(response, 'recommendedSolutions');
  return {
    type: types.RECEIVE_POPULAR_LIST,
    payload: {
      experience,
      articles,
    },
  };
}
function receivePopularQuestionsError() {
  return {
    type: types.RECEIVE_POPULAR_ERROR,
  };
}

export default function getPopularQuestions(experience) {
  return (dispatch) => {
    dispatch(requestPopularQuestions());
    return axios.get('/smarthelp/recommended-solutions')
      .then(response => dispatch(receivePopularQuestions(response.data, experience)))
      .catch(() => {
        dispatch(receivePopularQuestionsError());
      });
  };
}



// WEBPACK FOOTER //
// ./home/actions/action-popular-list.js